<section id="dynamic-category-header-2345674" class="dynamic-header-background editable">
    <div class="header-layout-10">
        <!-- search dropdown -->
        @if (isSearchOverlay && headerData.searchIcon.isVisibleOnDesktop) {
        <div class="search-drop-down-container" (click)="toggleSearchDropDown()">
            <div class="search-drop-down dynamic-header-background" (click)="$event.stopPropagation()">
                <h5 class="dynamic-header-text-color">Start your amazing search :</h5>

                <button class="close-btn" (click)="toggleSearchDropDown()">
                    <img src="https://assets.hyperinvento.com/hyperinventory_admin/dynamic-home-assets/common/close-line-icon.png" />
                </button>

                <base-search-bar [selectedDeviceType]="deviceType()" [headerData]="headerData" (searchProduct$)="searchProduct($event)" [searchInputControl]="searchInputControl" (searchIconClick$)="searchIconClick()" [isFocused]="isSearchOverlay">
                </base-search-bar>
            </div>
        </div>
        }

        <div class="logo-hamburger-cart-icon-main-container">
            <div class="logo-hamburger-wrapper">
                @if (isMobile() && headerData.menuListVisibleOnMobile) {
                <img (click)="toggleHamburgerMenu()" class="hamburger-btn" [src]="headerData.hamburgerMenuIcon" />
                }

                <!-- logo switch -->
                @if (headerData.logo.isVisibleOnMobile && isMobile()) {
                <a [routerLink]="['/']" class="logo dynamic-header-background">
                    <img class="static-header-logo" [src]="headerData.logo.logoSrc" />
                </a>
                } @else if (headerData.logo.isVisibleOnDesktop && isDesktop()) {
                <a [routerLink]="['/']" class="logo dynamic-header-background">
                    <img class="static-header-logo" [src]="headerData.logo.logoSrc" />
                </a>
                }
            </div>

            <div class="operation-button-container">
                <!-- search icons -->
                @if (headerData.searchIconMobile.isVisibleOnMobile && isMobile()) {
                <a class="button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" (click)="toggleSearchDropDown()">
                    <img [src]="headerData.searchIcon.searchIconSrc" />
                </a>
                } @else if (headerData.searchIcon.isVisibleOnDesktop && isDesktop()) {
                <a class="button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" (click)="toggleSearchDropDown()">
                    <img [src]="headerData.searchIcon.searchIconSrc" />
                </a>
                }
            </div>
        </div>

        <!-- account + cart -->
        <div class="nav-operation-button-main-container">
            <div class="operation-button-container">
                <!-- account -->
                @if (headerData.accountIcon.isVisibleOnMobile && isMobile()) {
                <a (click)="isHamburgerMenu = false" [target]="headerData.accountIcon.target" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']" class="button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius">
                    <img [src]="headerData.accountIcon.accountIconSrc" />
                </a>
                } @else if (headerData.accountIcon.isVisibleOnDesktop && isDesktop()) {
                <a [target]="headerData.accountIcon.target" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']" class="button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius">
                    <img [src]="headerData.accountIcon.accountIconSrc" />
                </a>
                }

                <!-- cart -->
                @if (headerData.cartIcon.isVisibleOnMobile && isMobile()) {
                <a (click)="isHamburgerMenu = false" [target]="headerData.cartIcon.target" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']" class="button cart-btn dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius">
                    <img [src]="headerData.cartIcon.cartIconSrc" />
                    <span class="cart-count dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">
                        {{ cart().cart_items.length }}
                    </span>
                </a>
                } @else if (headerData.cartIcon.isVisibleOnDesktop && isDesktop()) {
                <a [target]="headerData.cartIcon.target" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']" class="button cart-btn dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius">
                    <img [src]="headerData.cartIcon.cartIconSrc" />
                    <span class="cart-count dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">
                        {{ cart().cart_items.length }}
                    </span>
                </a>
                }
            </div>
        </div>

        <!-- hamburger menu -->
        @if (isHamburgerMenu && isMobile() && headerData.menuListVisibleOnMobile) {
        <div appClickOutside #changeHeaderMobileElement class="hamburger-menu-container" (click)="toggleHamburgerMenu()">
            <div class="hamburger-menu mobile-category-panel" (click)="$event.stopPropagation()">
                <static-menu-collapse (hideMenu$)="toggleHamburgerMenu()" [headerData]="headerData"> </static-menu-collapse>

                @if (
                (dynamicHeaderInline() && layoutType() === 'inlineLayout1') ||
                (dynamicHeaderHover() && layoutType() === 'hoverLayout1')
                ) {
                <webstore-dynamic-menu-collapse #dynamicCategoryHeaderMobile [categories]="category()" [menuCollapseIcon]="headerData.menuCollapseIcon" (hideMenu$)="toggleHamburgerMenu()">
                </webstore-dynamic-menu-collapse>
                }

                <button class="hamburger-menu-close-btn" (click)="toggleHamburgerMenu()">
                    <img src="https://assets.hyperinvento.com/hyperinventory_admin/dynamic-home-assets/common/close-line-icon.png" class="hamburger-menu-close-btn-icon" />
                </button>
            </div>
        </div>
        }
    </div>
</section>